<template>
  <b-modal
    :visible="value"
    title="Envio de Teste"
    modal-class="envio-teste-modal"
    centered
    @hidden="fecharModal"
  >
    <b-form @submit.prevent="enviarTeste">
      <!-- Seleção de Template -->
      <b-form-group
        label="Template"
        label-for="template_name"
        :state="validacao.template_name"
      >
        <div
          v-if="templates.length === 0 && !carregandoTemplates"
          class="no-templates-alert"
        >
          <b-alert
            show
            variant="warning"
            class="mb-0"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="16"
              class="mr-50"
            />
            Nenhum template disponível. Crie e aprove templates no WhatsApp primeiro.
          </b-alert>
        </div>

        <div
          v-else
          class="template-selector"
        >
          <div
            v-if="!form.template_name"
            class="template-empty"
            @click="abrirModalTemplates"
          >
            <feather-icon
              icon="FileTextIcon"
              size="32"
              class="text-dark mb-2"
            />
            <p class="mb-1">
              <strong class="text-dark">Selecionar Template</strong>
            </p>
            <small class="text-muted">Clique para escolher um template</small>
          </div>
          <div
            v-else
            class="template-selected"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="CheckCircleIcon"
                  size="20"
                  class="text-success mr-2"
                />
                <div>
                  <strong>{{ form.template_name }}</strong>
                  <br>
                  <small class="text-muted">Template selecionado</small>
                </div>
              </div>
              <div>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="abrirModalTemplates"
                >
                  <feather-icon
                    icon="RefreshCwIcon"
                    size="14"
                    class="mr-50"
                  />
                  Trocar
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <b-form-invalid-feedback :state="validacao.template_name">
          Selecione um template
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Número de Telefone -->
      <b-form-group
        label="Número de Telefone"
        label-for="phone"
        description="Formato: 5511999999999 (código do país + DDD + número)"
        :state="validacao.phone"
      >
        <b-input-group>
          <b-input-group-prepend is-text>
            <feather-icon
              icon="PhoneIcon"
              size="16"
            />
          </b-input-group-prepend>
          <b-form-input
            id="phone"
            v-model="form.phone"
            placeholder="5511999999999"
            :state="validacao.phone"
            @input="formatarTelefone"
          />
        </b-input-group>
        <b-form-invalid-feedback :state="validacao.phone">
          Número de telefone inválido. Use o formato: 5511999999999
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Preview do Template -->
      <div
        v-if="templateSelecionado"
        class="template-preview mt-3"
      >
        <h6 class="mb-2">
          <feather-icon
            icon="EyeIcon"
            size="16"
            class="mr-50"
          />
          Preview
        </h6>
        <whats-app-preview
          :template="templateSelecionado"
          :custom-image="null"
          class="preview-small"
        />
      </div>
    </b-form>

    <!-- Modal de Seleção de Templates -->
    <modal-selecao-templates
      v-model="modalTemplatesVisivel"
      :templates="templates"
      :carregando="carregandoTemplates"
      @template-selecionado="onTemplateSelecionado"
    >
      <template #info-text>
        <strong>Apenas templates aprovados</strong> pelo WhatsApp estão disponíveis para uso em campanhas.
      </template>
      <template #empty-text>
        Crie templates e aguarde a aprovação do WhatsApp para utilizá-los em campanhas.
      </template>
    </modal-selecao-templates>

    <!-- Modal de Confirmação de Envio -->
    <b-modal
      v-model="modalConfirmacaoVisivel"
      title="Confirmar Envio"
      modal-class="confirmacao-envio-modal"
      centered
      no-close-on-backdrop
      hide-footer
    >
      <div class="confirmacao-body text-center">
        <div class="confirmacao-icone mb-3">
          <feather-icon
            icon="AlertTriangleIcon"
            size="48"
            class="text-warning"
          />
        </div>
        <h5 class="mb-2">
          Deseja realmente enviar?
        </h5>
        <b-alert
          show
          variant="warning"
          class="text-left mb-3"
        >
          <feather-icon
            icon="DollarSignIcon"
            size="16"
            class="mr-50"
          />
          <strong>Atenção, você será cobrado por essa mensagem.</strong>
          <br>
          O valor é o mesmo de envio por template, aproximadamente <strong>R$ 0,35</strong> por mensagem.
        </b-alert>
        <div
          class="d-flex justify-content-center"
          style="gap: 0.75rem;"
        >
          <b-button
            variant="outline-secondary"
            @click="modalConfirmacaoVisivel = false"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            :disabled="enviando"
            @click="confirmarEnvio"
          >
            <b-spinner
              v-if="enviando"
              small
              class="mr-1"
            />
            <feather-icon
              v-else
              icon="SendIcon"
              size="16"
              class="mr-50"
            />
            {{ enviando ? 'Enviando...' : 'Confirmar Envio' }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Footer -->
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button
          variant="secondary"
          @click="fecharModal"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          :disabled="!formularioValido || enviando"
          @click="enviarTeste"
        >
          <b-spinner
            v-if="enviando"
            small
            class="mr-1"
          />
          <feather-icon
            v-else
            icon="SendIcon"
            size="16"
            class="mr-50"
          />
          {{ enviando ? 'Enviando...' : 'Enviar Teste' }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ModalSelecaoTemplates from '@core/components/modal-selecao-templates/ModalSelecaoTemplates.vue'
import { buscarTemplates, enviarMensagemTeste, normalizarTelefoneE164Brasil } from '@/functions/basics/campaign-oficial'
import WhatsAppPreview from './WhatsAppPreview.vue'

export default {
  name: 'ModalEnvioTeste',
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BSpinner,
    BAlert,
    FeatherIcon,
    WhatsAppPreview,
    ModalSelecaoTemplates,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    storeUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        template_name: null,
        phone: '',
      },
      templates: [],
      carregandoTemplates: false,
      modalTemplatesVisivel: false,
      enviando: false,
      tentouEnviar: false,
      modalConfirmacaoVisivel: false,
    }
  },
  computed: {
    validacao() {
      if (!this.tentouEnviar) {
        return {
          template_name: null,
          phone: null,
        }
      }

      const phoneFormatado = this.form.phone.replace(/\D/g, '')

      return {
        template_name: !!this.form.template_name,
        phone: phoneFormatado.length >= 10 && phoneFormatado.length <= 15,
      }
    },
    formularioValido() {
      const phoneFormatado = this.form.phone.replace(/\D/g, '')
      return (
        this.form.template_name
        && phoneFormatado.length >= 10
        && phoneFormatado.length <= 15
      )
    },
    templateSelecionado() {
      if (!this.form.template_name) return null
      return this.templates.find(t => t.name === this.form.template_name)
    },
  },
  watch: {
    value(visivel) {
      if (visivel) {
        this.carregarTemplates()
        this.resetForm()
      }
    },
  },
  methods: {
    async carregarTemplates() {
      this.carregandoTemplates = true
      try {
        const response = await buscarTemplates(this.storeUuid)

        let templates = []
        if (Array.isArray(response)) {
          templates = response
        } else if (response.data) {
          templates = Array.isArray(response.data) ? response.data : []
        } else if (response.templates) {
          templates = response.templates
        } else if (typeof response === 'object' && response !== null) {
          templates = Object.values(response)
        }

        // Filtrar templates de PIX (ORDER_DETAILS)
        templates = templates.filter(template => {
          if (template.components && Array.isArray(template.components)) {
            const buttonsComponent = template.components.find(comp => comp.type === 'BUTTONS')
            if (buttonsComponent?.buttons && Array.isArray(buttonsComponent.buttons)) {
              const temBotaoPix = buttonsComponent.buttons.some(button => button.type === 'ORDER_DETAILS' || button.type === 'order_details')
              if (temBotaoPix) return false
            }
          }
          return true
        })

        this.templates = templates
      } catch (error) {
        console.error('Erro ao carregar templates:', error)
        this.$bvToast.toast('Erro ao carregar templates', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.carregandoTemplates = false
      }
    },

    abrirModalTemplates() {
      this.modalTemplatesVisivel = true
    },

    onTemplateSelecionado(templateData) {
      this.form.template_name = templateData.name
      this.$bvToast.toast(`Template "${templateData.name}" selecionado!`, {
        title: 'Template Selecionado',
        variant: 'success',
        solid: true,
        autoHideDelay: 2000,
      })
    },

    formatarTelefone() {
      // Remove caracteres não numéricos
      this.form.phone = this.form.phone.replace(/\D/g, '')
    },

    resetForm() {
      this.form = {
        template_name: null,
        phone: '',
      }
      this.tentouEnviar = false
    },

    enviarTeste() {
      this.tentouEnviar = true

      if (!this.formularioValido) {
        this.$bvToast.toast('Preencha todos os campos corretamente', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.modalConfirmacaoVisivel = true
    },

    async confirmarEnvio() {
      this.enviando = true

      try {
        const phone = normalizarTelefoneE164Brasil(this.form.phone.replace(/\D/g, ''))
        const dados = {
          template_name: this.form.template_name,
          phone,
        }

        const resultado = await enviarMensagemTeste(this.storeUuid, dados)

        if (resultado.success) {
          this.modalConfirmacaoVisivel = false
          this.$bvToast.toast(`Mensagem de teste enviada para ${dados.phone}!`, {
            title: 'Sucesso',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          })
          this.fecharModal()
        } else {
          throw new Error(resultado.error || 'Erro desconhecido')
        }
      } catch (error) {
        console.error('Erro ao enviar mensagem de teste:', error)

        let mensagemErro = 'Erro ao enviar mensagem de teste'
        if (error.response?.data?.error) {
          mensagemErro = error.response.data.error
        } else if (error.message) {
          mensagemErro = error.message
        }

        this.$bvToast.toast(mensagemErro, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 8000,
        })
      } finally {
        this.enviando = false
      }
    },

    fecharModal() {
      this.resetForm()
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
::v-deep .envio-teste-modal .modal-dialog {
  max-width: 500px;
}

.template-selector {
  margin-bottom: 0.5rem;
}

.template-empty {
  border: 2px dashed #d8d6de;
  border-radius: 12px;
  padding: 1.5rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.template-empty:hover {
  border-color: #9a3092;
  background: #f9f0f8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(154, 48, 146, 0.15);
}

.template-selected {
  border: 2px solid #28c76f;
  border-radius: 12px;
  padding: 1rem;
  background: #f0fff4;
  transition: all 0.3s ease;
}

.no-templates-alert {
  margin-bottom: 0.5rem;
}

.template-preview {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.preview-small {
  transform: scale(0.85);
  transform-origin: top center;
}

.preview-small ::v-deep .whatsapp-preview-container {
  max-height: 300px;
  overflow-y: auto;
}

::v-deep .confirmacao-envio-modal .modal-dialog {
  max-width: 420px;
}

.confirmacao-body {
  padding: 0.5rem 0;
}

.confirmacao-icone {
  display: flex;
  justify-content: center;
}
</style>
